import { JobKindEnum } from 'graphql-common';
import { TFunction } from 'i18next';

const getJobTitle = (kind: JobKindEnum | null, t: TFunction): string => {
  const titles: Record<JobKindEnum, string> = {
    [JobKindEnum.QrCodeGeneration]: t('generating-qr-codes'),
    [JobKindEnum.TimelineReportGeneration]: t('generating-report'),
    [JobKindEnum.DataImport]: t('importing-records'),
  };

  return kind ? titles[kind] : t('generating-action');
};

export default getJobTitle;
